import {logger} from 'common'
import {useSession} from 'next-auth/react'
import {FC, useEffect} from 'react'

import {signOut} from '@/utils/auth/signOut'
import {useNavigation} from '@/utils/hooks/useNavigation'
import {routeTo} from '@/utils/router'

const SessionChecker: FC = () => {
  const router = useNavigation()
  const {data: session} = useSession()

  useEffect(() => {
    const checkSession = async () => {
      if (session?.error === 'ErrorRefreshingToken') {
        logger.info({email: session?.user?.email, id: session?.user?.id}, 'Logging user out')
        await signOut({redirect: false})
        await router.replace(routeTo.portal.login())
      }
    }
    checkSession()
  }, [router, session])

  return null
}

export default SessionChecker
